'use client'

import DarkModeToggle from '@/components/dark-mode-toggle'
import useDarkModeStore from '@/hooks/utils/dark-mode'

const AuthCard = ({ logo, children }) => {
    const { isDarkMode, toggleDarkMode } = useDarkModeStore()

    return (
        <div
            className={`min-h-screen ${isDarkMode ? 'magicpattern-dark' : 'magicpattern'}  px-4`}>
            {/* Dark mode toggle — fixed top right */}

            <div className="flex justify-end py-4">
                <DarkModeToggle
                    isDarkMode={isDarkMode}
                    toggleDarkMode={toggleDarkMode}
                />
            </div>
            <div className="flex flex-col items-center justify-center pb-4">
                {/* Frosted glass card */}
                <div className="w-full max-w-md">
                    <div className="bg-white/10 backdrop-blur-xl border border-white/20 rounded-3xl shadow-2xl px-8 pt-8 pb-10">
                        {/* Logo + title */}
                        <div className="flex flex-col items-center mb-8">
                            <div className="w-16 h-16 flex items-center justify-center rounded-2xl bg-white/15 border border-white/25 shadow mb-4">
                                {logo}
                            </div>
                            <h1 className="text-white text-2xl font-bold tracking-tight">
                                Welcome back
                            </h1>
                            <p className="text-white/50 text-sm mt-1">
                                Sign in to your account
                            </p>
                        </div>
                        {children}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default AuthCard
